import { useCallback, useState } from 'react';

import { useSearchShares } from '@frontend/api';

import ExpandableFilterList from '../components/ExpandableFilterList';
import SearchResultList from '../components/SearchResultList';
import Searching from '../components/Searching';
import ShareMatchCell from '../components/ShareMatchCell';
import { TABS } from '../constants';
import { useSearchDataContext } from '../context';
import {
  buildFilterSeeMore,
  buildFilterUpdate,
} from '../utils/buildFilterUpdate';

const ALWAYS_VISIBLE_FIELDS = [
  'partName',
  'partNumber',
  'revision',
  'accountName',
  'contactEmail',
  'contactFullName',
  'message',
  'number',
  'sharedByEmail',
];

const ShareResultList = () => {
  const { userHasTyped, query, activeTab } = useSearchDataContext();

  const [paginateFrom, setPaginateFrom] = useState(query.shares.paginateFrom);
  const [filters, setFilters] = useState(query.shares.filters);

  const { data: shares } = useSearchShares(
    {
      ...query.shares,
      paginateFrom,
      filters,
    },
    {
      queryOptions: {
        keepPreviousData: true,
        enabled: activeTab === TABS.SHARES,
      },
    },
  );

  const onBusinessNameChange = useCallback(
    (businessName) =>
      buildFilterUpdate(setFilters, 'businessNames')(businessName),
    [],
  );

  const onBusinessNameSeeMore = useCallback(
    () => buildFilterSeeMore(setFilters, 'businessNames')(),
    [],
  );
  if (userHasTyped) {
    return <Searching />;
  }

  return (
    <SearchResultList
      data={shares}
      tabKey={TABS.SHARES}
      title="Shared with Me"
      labelPlural="Shares"
      labelSingular="Share"
      matchCell={(result) => <ShareMatchCell shareResult={result} />}
      highlightConfig={{
        alwaysVisibleFields: ALWAYS_VISIBLE_FIELDS,
        children: {
          comments: [{ field: 'content', key: 'comments', label: 'Comments' }],
          partFiles: [
            { field: 'filename', key: 'partFiles', label: 'Part Files' },
          ],
          wordSpans: [
            { field: 'text', key: 'wordSpans', label: 'PDF Text Matches' },
          ],
        },
        allowLinks: ['comments', 'wordSpans'],
      }}
      filters={
        <ExpandableFilterList
          agg={shares?.aggs.businessNameAgg}
          label="Business Name"
          selectedKeys={filters.businessNames.values}
          onClick={onBusinessNameChange}
          onSeeMore={onBusinessNameSeeMore}
        />
      }
      paginationInfo={{
        paginateFrom,
        paginateSize: query.shares.paginateSize,
      }}
      onPaginate={(pagination) => setPaginateFrom(pagination.paginateFrom)}
    />
  );
};

export default ShareResultList;
